import React from 'react';
import './Contact.css';

const INSTAGRAM_URL = 'https://www.instagram.com/vikkygoldpalace/';
const WHATSAPP_E164 = '919092355957';
const WHATSAPP_DISPLAY = '90923 55957';

/* Store: https://maps.app.goo.gl/LFrAyMbQSmD5S6UL9 (VIKKY GOLD PALACE) */
const MAP_EMBED =
  'https://www.google.com/maps?q=10.5330023,79.6386239&z=17&hl=en&output=embed';

export default function Contact() {
  return (
    <div className="contact-page">
      <header className="contact-hero">
        <div className="contact-hero-glow" aria-hidden />
        <div className="contact-hero-inner">
          <p className="contact-eyebrow">Visit & connect</p>
          <h1>Contact Us</h1>
          <p className="contact-hero-lead">
            We are here to help with jewellery enquiries, custom orders, and store visits. Reach out anytime
            during business hours.
          </p>
        </div>
      </header>

      <div className="contact-shell">
        <section className="contact-bento" aria-labelledby="contact-visit-heading contact-map-heading">
          <div className="contact-bento-main">
            <h2 id="contact-visit-heading" className="contact-section-title">
              Visit & reach us
            </h2>
            <p className="contact-section-sub">
              Step into Vikky Gold Palace or call ahead — we look forward to welcoming you.
            </p>

            <div className="contact-cards">
              <article className="contact-card contact-card-accent">
                <span className="contact-card-icon" aria-hidden>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <path d="M12 21s-7-4.5-7-11a7 7 0 1114 0c0 6.5-7 11-7 11z" />
                    <circle cx="12" cy="10" r="2.5" />
                  </svg>
                </span>
                <h3>Store</h3>
                <p>
                  48 H, DMC Rd,
                  <br />
                  Thruthuraipoondi,
                  <br />
                  Tamil Nadu 614713
                </p>
                <a
                  href="https://maps.app.goo.gl/LFrAyMbQSmD5S6UL9"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-card-link"
                >
                  Open in Google Maps →
                </a>
              </article>

              <article className="contact-card">
                <span className="contact-card-icon" aria-hidden>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
                  </svg>
                </span>
                <h3>Phone</h3>
                <a href={`tel:+${WHATSAPP_E164}`} className="contact-phone">
                  +91 {WHATSAPP_DISPLAY}
                </a>
              </article>

              <article className="contact-card">
                <span className="contact-card-icon" aria-hidden>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <rect x="3" y="3" width="18" height="18" rx="5" />
                    <circle cx="12" cy="12" r="3.5" />
                    <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" stroke="none" />
                  </svg>
                </span>
                <h3>Instagram</h3>
                <p>New designs, arrivals, and behind the scenes.</p>
                <a
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-card-link"
                >
                  @vikkygoldpalace →
                </a>
              </article>

              <article className="contact-card">
                <span className="contact-card-icon" aria-hidden>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.435 9.884-9.881 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                  </svg>
                </span>
                <h3>WhatsApp</h3>
                <p>Message us for enquiries, photos, and quick replies.</p>
                <a
                  href={`https://wa.me/${WHATSAPP_E164}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-card-link contact-card-link--whatsapp"
                >
                  Chat on WhatsApp →
                </a>
              </article>

              <article className="contact-card">
                <span className="contact-card-icon" aria-hidden>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <circle cx="12" cy="12" r="9" />
                    <path d="M12 7v6l4 2" />
                  </svg>
                </span>
                <h3>Hours</h3>
                <p>
                  Monday – Sunday
                  <br />
                  <strong className="contact-hours-strong">9:00 AM – 9:00 PM</strong>
                </p>
              </article>
            </div>
          </div>

          <div className="contact-map-panel">
            <h2 id="contact-map-heading" className="contact-map-heading">
              Location
            </h2>
            <p className="contact-map-lead">Store pin on the map — tap below for directions in Google Maps.</p>
            <div className="contact-map-frame">
              <div className="contact-map-frame-inner">
                <iframe
                  title="VikkyGoldPalace on Google Maps"
                  src={MAP_EMBED}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>
            </div>
            <p className="contact-map-caption">
              <a
                href="https://maps.app.goo.gl/LFrAyMbQSmD5S6UL9"
                target="_blank"
                rel="noopener noreferrer"
              >
                Larger map & directions
              </a>
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
